import { render, staticRenderFns } from "./hospitalReview.vue?vue&type=template&id=0578e0ac&scoped=true"
import script from "./hospitalReview.vue?vue&type=script&lang=js"
export * from "./hospitalReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0578e0ac",
  null
  
)

export default component.exports